import {
  createStyles,
  Grid,
  ListSubheader,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { PageFilter } from '../../../shared/src/data/pageFilter'
import PagesSelector from './PagesSelector'
import SaveButton from '../SaveButton'
import { ViewType } from './viewType'
import { S3Link } from '../../../shared/src/data/s3Link'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      padding: theme.spacing(2),
    },
    loading: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    selection: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
    },
    files: {
      marginTop: theme.spacing(1),
    },
    alertContainer: {
      width: '100%',
    },
  }),
)

type PagesSelectorProps = {
  viewTypesPages: Map<ViewType, number[]>
  setIsStepValid: (isValid: boolean) => void
  setFilesPageFilters: (pageFilters: PageFilter[]) => void
  saveExecutionParams: () => Promise<S3Link | undefined>
}

export default function FilesPagesSelector({
  viewTypesPages,
  setIsStepValid,
  setFilesPageFilters,
  saveExecutionParams,
}: PagesSelectorProps): JSX.Element {
  const classes = useStyles()
  return (
    <Grid className={classes.grid} container spacing={1}>
      <Grid item>
        <ListSubheader>
          Select start to end pages for each file seperated by '-'. if more then
          one separate by ';' (example: 5-6;10;14-16)
        </ListSubheader>
      </Grid>
        <Grid container spacing={1} alignItems='flex-end'>
          <PagesSelector
            viewTypesPages={viewTypesPages}
            setIsStepValid={setIsStepValid}
            setPageFilters={setFilesPageFilters}
          />
        </Grid>
        <SaveButton saveExecutionParams={saveExecutionParams}/>
    </Grid>
  )
}
